import {Action} from '@ngrx/store';
import {ModuleSubscription} from '../../../models/module-subscription';

export class GetModuleSubscriptionsSuccessAction implements Action {
  public static readonly type = 'GetModuleSubscriptionsSuccessAction';

  constructor(public moduleSubscriptions: ModuleSubscription[]) {
  }

  public type = GetModuleSubscriptionsSuccessAction.type;
}
